import { render, staticRenderFns } from "./UserAuthenticatedAccounts.vue?vue&type=template&id=20fc95f2&"
import script from "./UserAuthenticatedAccounts.vue?vue&type=script&lang=js&"
export * from "./UserAuthenticatedAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports